export default "__VITE_ASSET__ec03f251__"